import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/web3-game/blockchain_game_back.webp";

function Blockchaingameconcept() {
  return (
    <section
      className="blockchain_game_concept p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={11} xl={10} xxl={10} className="">
            <h2>
              Your Blockchain Game Concept and TekRevol’s Web3 Game Developers –
              <span>A Dynamic Duo for Tech-Led Success</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              We house strong teams of project managers, game story strategists,
              writers, UI/UX designers, art executives, quality assurance
              professionals and business analysts who love coding for a
              difference. and what’s more - we also have a good team of 12
              gamers who first-handedly experience the dopamine hits in our
              games!
            </p>
            <p>
              That’s why we are highly result-oriented. To bring stunning games
              to life, we combine custom technology stacks, beautiful graphics
              user-centric experiences so your players never miss a beat. With
              our technical expertise, niche experience, monetization strategy
              and technology stacks, here’s what additionally helps us establish
              a track record in building top-grossing games:
            </p>
            <ul>
              <li>Addictive habit loops that remind users of the game</li>
              <li>
                Irresistible triggers and challenge players to dare and spend
              </li>
              <li>
                Rewards that motivate players to engage with your game – for
                hours, months and years
              </li>
              <li>
                Secure Blockchain architecture that your users trust and
                interact with
              </li>
              <li>
                Gaming technical code that accommodates single players to
                professional P2P groups
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center mt-3 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/web3-game/blochain_game.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={617}
              height={599}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Blockchaingameconcept;
